import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  input,
  Output,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { LocationsFilterPipe } from './locationsFilter.pipe';
import {
  FiltersLocation,
  FiltersRegion,
} from '../../interfaces/region.interface';

@Component({
    selector: 'st-bc-top-header-filters',
    imports: [CommonModule, MultiSelectModule, FormsModule, LocationsFilterPipe],
    templateUrl: './bc-top-header-filters.component.html',
    styleUrls: ['./bc-top-header-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BCTopHeaderFiltersComponent {
  regions = input.required<FiltersRegion[]>();
  locations = input.required<FiltersLocation[]>();

  locationsFilters = output<FiltersLocation[]>();

  locationsActive = signal<'locations' | null>(null);
  regionsActive = signal<'regions' | null>(null);

  @Input({ required: true }) selectedRegions: FiltersRegion[] = [];
  @Output() selectedRegionsChange = new EventEmitter<string>();

  @Input({ required: true }) selectedLocations: FiltersLocation[] = [];
  @Output() selectedLocationsChange = new EventEmitter<string>();

  constructor(readonly cd: ChangeDetectorRef) {}

  openRegions(multiSelect: MultiSelect) {
    if (multiSelect.overlayViewChild) {
      multiSelect.overlayViewChild.styleClass =
        'multiselect-overlay-filter-position';
    }
    multiSelect.show();
  }

  onRegionChange() {
    this.selectedLocations = this.selectedLocations.filter(l =>
      this.selectedRegions.some(r => r.id === l.regionId),
    );
    this.locationsFilters.emit(this.selectedLocations);
    this.cd.detectChanges();
  }

  onLocationChange() {
    this.locationsFilters.emit(this.selectedLocations);
    this.cd.detectChanges();
  }

  regionsChange(ev: any) {
    this.selectedRegionsChange.emit(ev);
    this.cd.detectChanges();
  }

  locationsChange(ev: any) {
    this.selectedLocationsChange.emit(ev);
    this.cd.detectChanges();
  }
}
